/**
 * Runtime Environment Helper
 *
 * In production (Docker), the entrypoint script reads the .env file from disk
 * at container startup and writes window.__env__ into /config.js, which is
 * loaded by index.html before the app bundle.
 *
 * In local development, import.meta.env is used as the fallback so Vite's
 * normal .env handling continues to work unchanged.
 */

// Augment the global Window type so TypeScript knows about __env__
declare global {
  interface Window {
    __env__?: Record<string, string>
  }
}

/**
 * Get a configuration value.
 * Priority: window.__env__ (runtime) → import.meta.env (build-time / dev)
 */
export function getEnv(key: string): string {
  return window.__env__?.[key] ?? (import.meta.env[key] as string | undefined) ?? ''
}
